/**
 * Extract the first brace-balanced JSON object that looks like a structured
 * assistant reply (has advice/products/routine/general keys). Handles text
 * where a greedy {…} regex would span too far or fail.
 */
export function extractStructuredJsonObject(text) {
  const s = String(text).trimStart();
  outer: for (let start = 0; start < s.length; start++) {
    if (s[start] !== '{') continue;
    let depth = 0;
    for (let i = start; i < s.length; i++) {
      const c = s[i];
      if (c === '{') depth++;
      else if (c === '}') {
        depth--;
        if (depth === 0) {
          const chunk = s.slice(start, i + 1);
          try {
            const parsed = JSON.parse(chunk);
            if (parsed && typeof parsed === 'object' && parsed.type === 'product_analysis') {
              continue outer;
            }
            if (
              parsed &&
              typeof parsed === 'object' &&
              ['advice', 'products', 'routine', 'general'].some((k) =>
                Object.prototype.hasOwnProperty.call(parsed, k)
              )
            ) {
              return parsed;
            }
          } catch (_) {
            /* try next { */
          }
          continue outer;
        }
      }
    }
  }
  return null;
}

/** Ensure Advice / Products / Routine keys exist so tab UI matches the Son:mi layout */
export function normalizeStructuredContent(obj) {
  if (!obj || typeof obj !== 'object' || obj.type) return obj;
  if (!['advice', 'products', 'routine', 'general'].some((k) => Object.prototype.hasOwnProperty.call(obj, k))) {
    return obj;
  }
  const out = { ...obj };
  for (const k of ['advice', 'products', 'routine']) {
    if (!(k in out)) out[k] = null;
  }
  return out;
}
